import { render } from "./sharepointFiles.vue?vue&type=template&id=237256b0"
import script from "./sharepointFiles.vue?vue&type=script&lang=js"
export * from "./sharepointFiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__